export default __webpack_public_path__ + "static/media/logoPABranco.5e17d766.png";